import React, { useState, useEffect, useCallback } from "react";

function CandidateForm() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [name, setName] = useState("");
  const [party, setParty] = useState("");
  const [candidatePhoto, setCandidatePhoto] = useState(null);
  const [partyPhoto, setPartyPhoto] = useState(null);
  const [message, setMessage] = useState("");
  const [candidates, setCandidates] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("party", party);
    if (candidatePhoto) formData.append("candidate_photo", candidatePhoto);
    if (partyPhoto) formData.append("party_photo", partyPhoto);

    try {
      const res = await fetch(`${API_URL}/registerCandidate.php`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      setMessage(data.message);

      setName("");
      setParty("");
      setCandidatePhoto(null);
      setPartyPhoto(null);

      fetchCandidates();
    } catch (err) {
      setMessage("Error connecting to server");
    }
  };

  const fetchCandidates = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/getCandidates.php`);
      const data = await res.json();
      setCandidates(data);
    } catch (err) {
      console.error("Error fetching candidates:", err);
    }
  }, [API_URL]);

  useEffect(() => {
    fetchCandidates();
  }, [fetchCandidates]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this candidate?")) return;

    try {
      const res = await fetch(`${API_URL}/deleteCandidate.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      alert(data.message);
      fetchCandidates();
    } catch (err) {
      console.error("Error deleting candidate:", err);
    }
  };

  return (
    <div>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow p-4">
              <h3 className="text-center mb-4">Candidate Registration</h3>
              <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Candidate Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">Party Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Party Name"
                      value={party}
                      onChange={(e) => setParty(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Candidate Photo</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => setCandidatePhoto(e.target.files[0])}
                    accept="image/*"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Party Symbol</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => setPartyPhoto(e.target.files[0])}
                    accept="image/*"
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Register
                </button>
              </form>

              {message && <p className="text-center mt-3">{message}</p>}
            </div>
          </div>

          <div className="col-md-6">
            <h3 className="mb-3">Registered Candidates</h3>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Candidate</th>
                  <th>Party</th>
                  <th>Candidate Photo</th>
                  <th>Party Symbol</th>
                  <th>Registered At</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {candidates.map((c, index) => (
                  <tr key={c.id}>
                    <td>{index + 1}</td>
                    <td>{c.name}</td>
                    <td>{c.party}</td>
                    <td>
                      {c.candidate_photo ? (
                        <img
                          src={`${API_URL}/${c.candidate_photo}`}
                          alt="candidate"
                          width="50"
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>
                    <td>
                      {c.party_photo ? (
                        <img
                          src={`${API_URL}/${c.party_photo}`}
                          alt="party"
                          width="50"
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>
                    <td>{c.created_at}</td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(c.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CandidateForm;
